import { Sns } from "../gql/graphql";

export interface DOMRoutes {
  path: string;
  key?: string;
  component: JSX.Element;
}

export interface AttrInfoSet {
  label?: string;
  value?: string;
}

export interface saveJson {
  typeName: string;
  attrs: ProductAttrTypes[];
}
export interface ProductAttrTypes {
  value: string;
  name: string;
}

export interface SnsState {
  email?: string;
  sns?: Sns;
}

export interface AddressInfo {
  regionKey?: string;
  mainAddress?: string;
  zoneCode?: string;
}

export enum HowToReceive {
  Delivery = "Delivery",
  PickUp = "PickUp",
}

export enum UserCouponStatus {
  AVAILABLE = "AVAILABLE", // 사용 가능
  USED = "USED", // 사용됨
  EXPIRED = "EXPIRED", // 만료됨
}
export enum CouponScope {
  GLOBAL = "GLOBAL", // 전체 서비스
  LINK_SERVICE = "LINK_SERVICE", // 특정 지역(LinkService)
  CORPORATION = "CORPORATION", // 특정 매장
}

export enum CouponStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  EXPIRED = "EXPIRED",
}
